<template>
  <Card>
    <NoteForm />
  </Card>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import NoteForm from '../forms/NoteForm.vue';
import Card from './_shared/Card.vue';

export default defineComponent({
  components: {
    Card,
    NoteForm,
  },
});
</script>
